export default [
  {
    path: '/404',
    name: '404',
    meta: { requiresAuth: true },
    component: () => import('@/pages/404.vue')
  }
]
